"use strict";
// More detail about Epsy colours:
// https://app.zeplin.io/project/5ed0e9b854fdbb9b35a87c57/screen/5ed660171a1c5a218788d839
Object.defineProperty(exports, "__esModule", { value: true });
var primary = {
    purple: "#400198",
    pink: "#f20493"
};
var secondary = {
    indigo: "#251c75",
    marine: "#4d07fb",
    violet: "#AD0CFF",
    teal: "#00ADBC",
    blue: "#0092ff",
    sky: "#3dc0f6",
    orange: "#E87613"
};
var shade = {
    1: "rgba(0,0,0,0.85)",
    2: "#606060",
    3: "#A3A3A3",
    4: "#E8E8E8",
    5: "#F2F2F2",
    6: "#FAFBFD",
    white: "#FFF"
};
var traffic = {
    alertRed: "#DA265C",
    green: "#04C57F"
};
var colors = { primary: primary, secondary: secondary, shade: shade, traffic: traffic };
exports.default = colors;
